import { ScreenPropAreaLocationItem } from "~/navigation/Navigation.types";

import { AreaLocationItem } from "./AreaLocation.Item";

export const AreaLocationItemScreen = (props: ScreenPropAreaLocationItem) => {
  return <AreaLocationItem id={props.route.params.id} onClose={() => {}} />;
};
